import { FC } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import { Bolt, Start } from "@mui/icons-material";

const InterruptingChallengeSelector: FC = () => {
  const {
    challenge: { challenger, challengeMoment },
  } = useSelectedChallengeContext();

  const teamInterruptedGame = challengeMoment === "DURING_RALLY";

  return (
    <Card
      variant="elevation"
      elevation={5}
      sx={{
        flexDirection: "column",
        width: "350px",
        opacity: challenger === "referee" ? 0.6 : 1,
        display: "flex",
      }}
    >
      <CardHeader
        title={"Zeitraum der Beantragung"}
        titleTypographyProps={{ variant: "subtitle1", align: "center" }}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ flexGrow: 1, display: "flex" }}>
        <ToggleButtonGroup
          disabled={challenger === "referee"}
          color="primary"
          value={
            teamInterruptedGame && challenger !== "referee"
              ? "interrupting"
              : "nonInterrupting"
          }
          exclusive
          onChange={(event, value) => {
            throw new Error("InterruptingChallengeSelector not implemented!");
          }}
        >
          <ToggleButton value={"nonInterrupting"}>
            <Start />
            Nach dem Spielzug
          </ToggleButton>
          <ToggleButton value={"interrupting"}>
            <Bolt />
            Während des Spielzuges
          </ToggleButton>
        </ToggleButtonGroup>
      </CardContent>
    </Card>
  );
};

export default InterruptingChallengeSelector;
